import React from 'react'
import { useTranslation } from 'react-i18next'

export const DashboardContainer = () => {
  const { t } = useTranslation()

  return <>{t('dashboard')}</>
}
